Ext.define('SA.data.HtmlParser', {
    singleton: true,

    tail(html, startIndex) {
        if (typeof html === 'string') {
            html = SA.data.HtmlParser.tokenize(html);
        }

        if (startIndex < 0) {
            startIndex += html.length;
        }

        var tokens = html.tokens,
            index = tokens.length - 1,
            newTokens = [],
            lengthRemaining = html.length - startIndex,
            tail = {
                length: lengthRemaining,
                tokens: newTokens
            },
            token;

        for ( ; index >= 0 ; --index) {
            token = tokens[index];

            if (token.charAt(0) === '<') {
                newTokens.unshift(token);
            }
            else if (lengthRemaining) {
                if (token.charAt(0) === '&') {
                    newTokens.unshift(token);
                    --lengthRemaining;
                }
                else {
                    if (lengthRemaining > token.length) {
                        newTokens.unshift(token);
                        lengthRemaining -= token.length;
                    }
                    else {
                        newTokens.unshift(token.slice(-lengthRemaining));
                        lengthRemaining = 0;
                    }
                }
            }
        }

        return tail;
    },

    tokenize(html) {
        var index = 0,
            len = html.length,
            tokens = [],
            totalLength = 0,
            start = 0,
            ch;

        for ( ; index < len ; ++index) {
            ch = html.charAt(index);

            if (ch === '<') {
                flushText();
                readUntil('>');
            }
            else if (ch === '&') {
                flushText();
                readUntil(';');

                ++totalLength;
            }
        }

        flushText();

        return {
            length: totalLength,
            tokens
        };

        function readUntil(chr) {
            var end = html.indexOf(chr, index);

            tokens.push(html.slice(index, end + 1));

            index = end;
            start = index + 1;
        }

        function flushText() {
            if (start !== index) {
                tokens.push(html.slice(start, index));

                totalLength += index - start;
            }
        }
    }
});

